import { render, staticRenderFns } from "./LanguageIncomingOutgoing.vue?vue&type=template&id=dbf8e0ee"
import script from "./LanguageIncomingOutgoing.vue?vue&type=script&lang=js"
export * from "./LanguageIncomingOutgoing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports